import {createAction} from "@reduxjs/toolkit";
import {VolumeInventorySearchCriteria} from "@ots-frontend/ots-data";

export const setVolumeInventorySearchPageFilter = createAction<VolumeInventorySearchCriteria>("ui/volume-inventory-search-page/setFilter");
